import { useCallback } from 'react'

/**
 * A circular reference-free hook to combine a local ref and a forwarded ref.
 * @param localRef - A mutable ref object that will hold the current node.
 * @param forwardedRef - A ref object that will receive the forwarded node.
 * @returns A callback function that sets both refs to the same node.
 * @template T - The type of the HTML element.
 */
export const useCombinedRefs = <T extends HTMLElement>(
    localRef: React.MutableRefObject<T | null>,
    forwardedRef?: React.Ref<T>
) => {
    return useCallback(
        (node: T | null) => {
            localRef.current = node
            if (typeof forwardedRef === 'function') {
                forwardedRef(node)
            } else if (forwardedRef && 'current' in forwardedRef) {
                // @ts-ignore
                forwardedRef.current = node
            }
        },
        [forwardedRef]
    )
}
